import { render, staticRenderFns } from "./edit_tag.vue?vue&type=template&id=83f9c390&"
import script from "./edit_tag.vue?vue&type=script&lang=js&"
export * from "./edit_tag.vue?vue&type=script&lang=js&"
import style0 from "./edit_tag.vue?vue&type=style&index=0&id=83f9c390&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports